export enum VueButtonTypes {
  primary = 'btn btn-primary',
  default = 'btn btn-default',
  danger = 'btn btn-danger'
}